<!--
  作者：xiaoyu.li
  时间：2020年03月14日 13:45:18
-->
<template>
  <!-- <div class="coupon_info">
    <div
      class="coupon_type"
      :class="{
        'bg-2': info.couponType === 'DISCOUNT',
        'bg-3': info.couponType === 'GIFT',
        isPop: isPop
      }"
    >
      <div class="info_line">
        <div class="coupon_name">{{ info.onlineName }}</div>
        <div
          class="coupon_num"
          v-if="info.couponType === 'CASH' && info.couponAmount"
        >
          ¥{{ info.couponAmount }}
        </div>
        <div
          class="coupon_num"
          v-if="info.couponType === 'DISCOUNT' && info.couponAmount"
        >
          {{ info.couponAmount }}折
        </div>
        <div v-if="info.couponType === 'GIFT'">
          <image :src="info.goodsUrl" style="width: 20px; height: 20px;"></image>
        </div>
        <div class="coupon_num" v-if="!info.couponAmount && info.apply">
          凭证
        </div>
      </div>
      <div class="info_line">
        <div class="coupon_tip">{{ info.onlineDescription }}</div>
        <div class="date">
          有效期至{{ moment(info.expiredDate).format('YYYY-MM-DD HH:mm') }}
        </div>
      </div>
    </div>
  </div> -->
  <!-- NO.2 -->
  <!-- <div class="box-container flex-center"> -->
  <div class="coupon-bg flex-center" :class="{ type2: info.apply }">
    <div class="coupon-left" :class="{ 'type2-left': info.apply }">
      <img class="coupon-icon" :src="couponIcon[info.couponType]" />
      <div class="cash" style="display: flex;flex-wrap: wrap;align-items: center;">
        <span
          style="font-size: 20px;"
          v-if="info.couponType === 'CASH' && info.couponAmount"
          >¥</span
        >
        <span v-if="info.couponAmount">
          {{ info.couponAmount }}
        </span>
        <span
          style="font-size: 16px;margin-left: 2px;"
          v-if="info.couponType === 'DISCOUNT' && info.couponAmount"
          >折</span
        >
        <span
          v-if="info.couponType === 'GIFT'"
          style="margin-right: 4px;display:inline-block;"
        >
          <img :src="info.goodsUrl" style="width: 32px; height: 32px;" />
        </span>
        <div class="coupon_num" v-if="!info.couponAmount && info.apply">
          凭证
        </div>
        <span class="end-date"
          >有效期至{{ moment(info.expiredDate).format('YYYY-MM-DD') }}</span
        >
      </div>
      <div class="coupon-name">{{ info.onlineName }}</div>
    </div>
    <div
      class="coupon-right flex-center"
      :class="{ 'type2-right': info.apply }"
    >
      <!-- <img
        class="line"
        src="https://img.esenyun.com/images/20200630/c649d11fe3dd4fa694504ef5fb893226.png"
      /> -->
      <div v-if="!info.apply">
        <div v-if="!info.couponAmount && info.apply"></div>
        <div v-else>
          <div class="btn-coupon flex-center code" v-if="useSlot && !text">
            待领取
          </div>
          <div
            class="btn-coupon flex-center code2"
            v-if="useSlot && text === '已领取'"
          >
            已领取
          </div>
          <div
            class="end-date van-ellipsis"
            style="max-width: 80%;text-align:center;"
            v-if="useSlot && text && text !== '已领取'"
          >
            {{ text }}
          </div>
          <div class="btn-coupon flex-center" v-if="!useSlot">去领取</div>
        </div>
      </div>
      <div
        class="end-date van-ellipsis"
        style="max-width: 80%;text-align:center; margin-left: 0; line-height: normal; height: 14px;margin-top: 5px;"
      >
        {{ info.onlineDescription }}
      </div>
    </div>
  </div>
  <!-- </div> -->
</template>

<script>
export default {
  // 组件名称
  name: 'CouponType',
  // 组件参数 接收来自父组件的数据
  props: {
    useSlot: {
      type: Boolean,
      default: false,
    },
    text: {
      type: String,
      default: '',
    },
    info: {
      type: Object,
      default: function() {
        return {
          activityId: '', // 活动ID ,
          couponAmount: '', // 卡券金额 ,
          couponIcon: '',
          couponId: '', // 卡券id
          couponType: '', // 卡券类型 抵扣券CASH 折扣券DISCOUNT 实物券 GIFT ,
          createdBy: '', // 创建人 ,
          createdTime: '', // 创建时间 ,
          expiredDate: '', // 指定时间为BY_DATE 存储 ,
          expiredDays: '', // 指定时间为BY_DAYS 存储 ,
          expiredType: '', // 指定天数：BY_DAYS,BY_DATE ,
          getLimit: '', // 获取限制数量 ,
          getMethod: '', // 报名ENTER,新用户NEW_USER，免费GRATIS ,
          goodsUrl: '', // 实物券链接
          instructions: '', // 适用范围 ,
          lastModifiedBy: '', // 修改人 ,
          lastModifiedTime: '', // 修改时间 ,
          leastCost: '', // 使用门槛金额 ,
          needMobile: '', // 领券是否需要手机号 ,
          onlineDescription: '', // 卡券名称描述 ,
          onlineName: '', // 卡券名称显示 ,
          sellerLimit: '', // 库存数量 ,
          stockLimit: '', // 顾客限制数量 ,
          stockQuantity: '', // 库存数量 ,
          version: '', // 乐观锁版本号
        }
      },
    },
    // 是否弹窗中的卡券
    isPop: {
      type: Boolean,
      default: true,
    },
  },
  // 局部注册的组件
  components: {},
  // 组件状态值
  data() {
    return {
      couponIcon: {
        CASH:
          'https://img.esenyun.com/images/20200317/386c831efe5b4c2aa78d0758e0a22226.png',
        DISCOUNT:
          'https://img.esenyun.com/images/20200317/74de9957780c4bdb8212acf8b2651383.png',
        GIFT:
          'https://img.esenyun.com/images/20200317/c23c3d47520f416a99230945578821d4.png',
      },
    }
  },
  // 计算属性
  computed: {},
  mounted() {},
  // 组件方法
  methods: {},
}
</script>

<style lang="less" scoped>
.box-container {
  width: 100%;
  justify-content: center;
}
.coupon_info {
  background: url('https://img.esenyun.com/images/20200314/b4689be2b0af41e9a24d598c8dbd665e.png')
    no-repeat;
  background-size: 100% 100%;
  width: 100%;
  .info_line {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 10px;
    line-height: 20px;
    color: #9d7c64;
    .coupon_name {
      font-weight: 600;
      font-size: 20px;
      line-height: 22px;
      color: #fd533e;
    }
  }
}
.coupon_num {
  display: inline-block;
  font-weight: 600;
  font-size: 24px;
  line-height: 24px;
  text-align: right;
  color: #fd533e;
}
.coupon_type {
  padding: 18px 12px 8px 12px;
  background: url('https://img.esenyun.com/images/20200317/386c831efe5b4c2aa78d0758e0a22226.png')
    no-repeat;
  background-size: 57px;
  background-position: 65% center;
  &.isPop {
    background: url('https://img.esenyun.com/images/20200317/386c831efe5b4c2aa78d0758e0a22226.png')
      no-repeat;
    background-size: 57px;
    background-position: 70% center;
  }
}
.bg-2 {
  background: url('https://img.esenyun.com/images/20200317/74de9957780c4bdb8212acf8b2651383.png')
    no-repeat;
  background-size: 41px;
  background-position: 65% center;
  &.isPop {
    background: url('https://img.esenyun.com/images/20200317/74de9957780c4bdb8212acf8b2651383.png')
      no-repeat;
    background-size: 41px;
    background-position: 70% center;
  }
}
.bg-3 {
  background: url('https://img.esenyun.com/images/20200317/c23c3d47520f416a99230945578821d4.png')
    no-repeat;
  background-size: 46px;
  background-position: 65% center;
  &.isPop {
    background: url('https://img.esenyun.com/images/20200317/c23c3d47520f416a99230945578821d4.png')
      no-repeat;
    background-size: 46px;
    background-position: 70% center;
  }
}
.coupon-bg {
  width: 100%;
  height: 21vw;
  background: url('https://img.esenyun.com/images/20200630/8ebb82b0e43646dd9f791b7b4650408f.png')
    no-repeat;
  background-size: 100%;
  .coupon-left {
    width: calc(100% - 31vw);
    position: relative;
    .coupon-icon {
      width: 48px;
      height: 48px;
      position: absolute;
      right: 4vw;
      top: 0px;
    }
    .cash {
      font-weight: bold;
      font-size: 30px;
      // line-height: 24px;
      color: #fd533e;
      margin-left: 16px;
    }
    .coupon-name {
      padding-left: 16px;
      font-weight: 500;
      font-size: 12px;
      line-height: 17px;
      color: #fd533e;
    }
  }
  .type2-left {
    width: calc(100% - 23vw);
  }
  .end-date {
    font-size: 10px;
    // line-height: 20px;
    font-weight: normal;
    color: #9d7c64;
    margin-left: 4px;
  }
  .coupon-right {
    position: relative;
    flex-direction: column;
    justify-content: center;
    height: 100%;
    width: 31vw;
    .btn-coupon {
      width: 76px;
      height: 24px;
      font-weight: 500;
      font-size: 12px;
      justify-content: center;
      color: #fff;
      background: #fd533e;
      border-radius: 50px;
    }
    .code {
      background: #ffeadf;
      color: #fd533e;
    }
    .code2 {
      background: #ffeadf;
      color: #feb5a7;
    }
    .line {
      width: 1px;
      height: 46px;
      position: absolute;
      top: 22%;
      left: 4%;
    }
  }
  .type2-right {
    width: 23vw;
  }
}
.type2 {
  height: 17vw;
}
</style>
